import {ArrowDropDown} from "@mui/icons-material";
import {Chip} from "@mui/material";
import {Task2, TaskBoardCard, TaskBoardColumn} from "../../../api/Tasks2";
import {useState} from "react";
import {ChooseBoardStatus} from "./ChooseBoardStatus";
import {TaskTags} from "./TaskTags";
import TableChartIcon from '@mui/icons-material/TableChart';
import {AssignmentEdit} from "./AssignmentEdit";
import {WatcherEdit} from "./WatcherEdit";
import {Link} from "react-router-dom";
import {TaskDueDate} from "./TaskDueDate";

export function ViewTaskHeader(props: {
    card?: TaskBoardCard;
    column?: TaskBoardColumn;
    valueExt?: Task2;
    onUpdate(v: Task2): Promise<any>;
    onClose(): void;
}) {
    const [showChooseColumn, setShowChooseColumn] = useState<HTMLElement|null>(null);

    return (
        <>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 8,
                paddingLeft: 16, paddingRight: 16,
                paddingTop: 8,
            }}>
                {props.column && props.card && <div>
                    <Chip
                        label={props.column.boardTitle + " / " + props.column.title}
                        icon={<TableChartIcon />}
                        deleteIcon={<ArrowDropDown />}
                        size="small"
                        color="info"
                        onDelete={(e) => {
                            console.log("onDelete", e.target);
                            setShowChooseColumn(e.target)
                        }}
                    />

                    {showChooseColumn && <ChooseBoardStatus
                        anchorEl={showChooseColumn}
                        column={props.column}
                        card={props.card}
                        onClose={(tf: boolean = false) => {
                            setShowChooseColumn(null)
                            if(tf) props.onClose();
                        }}
                    />}
                </div>}
                {!props.column && !props.card && props.valueExt?.boardLinks && props.valueExt.boardLinks.length > 0 && <div>
                    {props.valueExt.boardLinks.map((v, i) => <div key={i}>
                        <Link to={v.boardUrl || ""}>
                            <Chip
                                label={v.boardName + " / " + v.columnName}
                                icon={<TableChartIcon />}
                                size="small"
                                color="info"
                                onClick={() => {
                                    props.onClose()
                                }}
                            />
                        </Link>
                    </div>)}
                </div>}
                <TaskDueDate value={props.valueExt?.dueDate || null} onChange={v => props.onUpdate(Object.assign({}, props.valueExt, {
                    dueDate: v,
                    events: null,
                    watchers: null,
                    assignment: null,
                }))} />
                <TaskTags value={props.valueExt?.tags || []} onChange={(v) => props.onUpdate(Object.assign({}, props.valueExt, {
                    tags: v,
                    events: null,
                    watchers: null,
                    assignment: null,
                }))} />
                <WatcherEdit value={props.valueExt?.watchers || []} task2={props.valueExt?.id || 0} />
            </div>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: 8,
                paddingLeft: 16, paddingRight: 16,
                paddingTop: 8,
            }}>
                Assigned: <AssignmentEdit value={props.valueExt?.assignment || []} task2={props.valueExt?.id || 0} />
            </div>
        </>
    )
}